
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Animations`}</h2>
    <p>{`CSS animations with `}<inlineCode parentName="p">{`@keyframes`}</inlineCode>{` aren't scoped to a single component but you still don't want them to be global to avoid name collisions. This is why we export a `}<inlineCode parentName="p">{`keyframes`}</inlineCode>{` helper which will generate a unique instance that you can use throughout your app:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// Create the keyframes
const rotate = keyframes\`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
\`;

// Here we create a component that will rotate everything we pass in over two seconds
const Rotate = styled.div\`
  display: inline-block;
  animation: \${rotate} 2s linear infinite;
  padding: 2rem 1rem;
  font-size: 1.2rem;
\`;

render(
  <Rotate>&lt; 💅🏾 &gt;</Rotate>
);
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Keyframes are not supported by `}<inlineCode parentName="p">{`react-native`}</inlineCode>{`. Instead, use the `}<a parentName="p" {...{
          "href": "https://stackoverflow.com/questions/50891046/rotate-an-svg-in-react-native/50891225#50891225"
        }}><inlineCode parentName="a">{`ReactNative.Animated`}</inlineCode>{` API`}</a>{`.`}</p>
    </blockquote>
    <p>{`Keyframes are lazily injected when they're used, which is how they can be code-split, so you have to use `}<a parentName="p" {...{
        "href": "/docs/api#css"
      }}>{`the `}<inlineCode parentName="a">{`css`}</inlineCode>{` helper`}</a>{` for shared style fragments:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const rotate = keyframes\`\`

// ❌ This will throw an error!
const styles = \`
  animation: \${rotate} 2s linear infinite;
\`

// ✅ This will work as intended
const styles = css\`
  animation: \${rotate} 2s linear infinite;
\`
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`This used to work in v3 and below where we didn't code-split keyframes. If you're upgrading from v3, make sure that all your shared style fragments are using the `}<inlineCode parentName="p">{`css`}</inlineCode>{` helper!`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;